import Input from "./Input";
import Button from "./Button";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import AutoComplete from "./AutoComplete";

const Controls = {
  Input,
  Button,
  Checkbox,
  DatePicker,
  AutoComplete,
};

export default Controls;
